(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("colors"), require("lodash.reduce"));
	else if(typeof define === 'function' && define.amd)
		define(["colors", "lodash.reduce"], factory);
	else if(typeof exports === 'object')
		exports["colur"] = factory(require("colors"), require("lodash.reduce"));
	else
		root["colur"] = factory(root["colors"], root["lodash.reduce"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition